/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../index';

/**
 * A publicly available representation of published CredentialSchema.
 */
export interface PublishedCredentialSchema {
    /**
     * The [Multibase](https://www.w3.org/TR/cid/#multibase)-encoded sha2-256 [Multihash](https://www.w3.org/TR/cid/#multihash) value.
     *
     * See [Resource Integrity](https://www.w3.org/TR/vc-data-integrity/#resource-integrity).
     */
    digestMultibase: string;
    /**
     * The [Multibase](https://www.w3.org/TR/cid/#multibase)-encoded sha2-256 [Multihash](https://www.w3.org/TR/cid/#multihash) value.
     *
     * See [Resource Integrity](https://www.w3.org/TR/vc-data-integrity/#resource-integrity).
     */
    jsonLdVocabDigestMultibase: string;
    /** Just regular URI according to [RFC 3986](https://www.rfc-editor.org/rfc/rfc3986). */
    jsonLdVocabUrl: string;
    /**
     * The [Multibase](https://www.w3.org/TR/cid/#multibase)-encoded sha2-256 [Multihash](https://www.w3.org/TR/cid/#multihash) value.
     *
     * See [Resource Integrity](https://www.w3.org/TR/vc-data-integrity/#resource-integrity).
     */
    jsonSchemaDigestMultibase: string;
    /** Just regular URI according to [RFC 3986](https://www.rfc-editor.org/rfc/rfc3986). */
    jsonSchemaUrl: string;
    /** Timestamp string according to [RFC 3339](https://www.rfc-editor.org/rfc/rfc3339). */
    publishedAt: Date;
    schema: Truvity.ClaimsSchema;
    /** Slug of a CredentialSchema. */
    slug: string;
    /** Just regular URI according to [RFC 3986](https://www.rfc-editor.org/rfc/rfc3986). */
    url: string;
    /**
     * The [Multibase](https://www.w3.org/TR/cid/#multibase)-encoded sha2-256 [Multihash](https://www.w3.org/TR/cid/#multihash) value.
     *
     * See [Resource Integrity](https://www.w3.org/TR/vc-data-integrity/#resource-integrity).
     */
    vcdmJsonSchemaDigestMultibase: string;
    /** Just regular URI according to [RFC 3986](https://www.rfc-editor.org/rfc/rfc3986). */
    vcdmJsonSchemaUrl: string;
    /** The version of the resource. */
    version: number;
}
